/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Nav_FaqInputs */

const en_hotel_nav_faq = /** @type {(inputs: Hotel_Nav_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Hotel_Nav_FaqInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const hotel_nav_faq = /** @type {((inputs?: Hotel_Nav_FaqInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Nav_FaqInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hotel_nav_faq(inputs)
});
export { hotel_nav_faq as "hotel.nav.faq" }